import { IDataSourceEntity } from "@gtmhub/insights";
import { IPromise, IHttpService } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { EnvironmentService } from "@gtmhub/env";
import { ILookerBuildInsightContext, ILookerEntity } from "../models/models";

export class LookerInsightSelectorService {
  static $inject = ["$http", "EnvironmentService", "$uibModal"];

  constructor(private $http: IHttpService, private env: EnvironmentService, private $uibModal: IModalService) {}

  openBuildInsightModal(args: ILookerBuildInsightContext): IPromise<IDataSourceEntity> {
    return this.$uibModal.open({
      windowClass: "insight-builder-modal",
      resolve: {
        connections: () => args.connections,
        blueprintName: () => args.blueprintName,
      },
      component: "lookerInsightBuilder",
    }).result;
  }

  getDashboards(connectionId: string): IPromise<ILookerEntity[]> {
    const url = this.env.getApiEndpoint(`/looker/${connectionId}/dashboards`);

    return this.$http.get(url).then((response) => {
      return response.data as ILookerEntity[];
    });
  }

  getTiles(connectionId: string, dashboardId: string): IPromise<ILookerEntity[]> {
    const url = this.env.getApiEndpoint(`/looker/${connectionId}/dashboard/${dashboardId}/tiles`);

    return this.$http.get(url).then((response) => {
      return response.data as ILookerEntity[];
    });
  }

  getLooks(connectionId: string): IPromise<ILookerEntity[]> {
    const url = this.env.getApiEndpoint(`/looker/${connectionId}/looks`);

    return this.$http.get(url).then((response) => {
      return response.data as ILookerEntity[];
    });
  }
}
